import React, { useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { Modal } from "react-responsive-modal";
import SignaturePad from "react-signature-canvas";

const SignatureSelector = (props) => {
  const { t } = useTranslation();
  const [openSig, setOpenSig] = useState(false);
  const [signature, setSignature] = useState(props.getSignature);
  const ref = React.createRef();

  const onOpenSigModal = () => {
    setOpenSig(true);
    const currentSignature =
      (props.getSignature && props.getSignature.uri) ||
      (signature && signature.uri());
    if (props.getRef) {
      ref.current = props.setRef();
    }
    if (!ref.current) {
      ref.current = document.querySelector("canvas");
    }
    if (ref.current && currentSignature) {
      ref.current.fromDataURL(currentSignature);
    }
  };

  const onCloseSigModal = () => {
    setOpenSig(false);

    const html = document.querySelector("html");
    html.style = "";
  };

  const handleOK = () => {
    const signatureObj = {
      uri: ref.current.getTrimmedCanvas().toDataURL("image/png"),
      name: "signature.png",
      type: "image/png",
    };
    setSignature(signatureObj);
    props.setSignature(signatureObj);
    props.setRef(ref.current);
    onCloseSigModal();
  };

  const handleClear = () => {
    ref.current.clear();
  };

  const customStyles = {
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      zIndex: "20",
      outline: "none",
      border: "none",
      width: "30px",
    },
    modal: {
      position: "relative",
      padding: "0",
    },
    overlay: {
      padding: "0",
    },
  };

  return (
    <div className="h-full">
      <div className="flex flex-col mb-14">
        <div
          onClick={() => onOpenSigModal()}
          className="cursor-pointer border rounded-2xl max-md-lg h-40 flex px-4 items-center justify-center"
          style={{ borderColor: props.borderColor }}>
          {!signature && (
            <div className="preCheckinTitle text-14 cursor-pointer flex px-4 mx-auto space-x-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              <p
                className="flex items-center text-center"
                style={{ color: props.color }}>
                {t("SIGNATURE")}
              </p>
            </div>
          )}
          {signature && (
            <img
              src={signature.uri}
              alt="signature"
              className="mx-auto h-full"
              onClick={() => onOpenSigModal()}
            />
          )}
        </div>
        {props.errors && props.errors["signature"] && (
          <p className="text-14 text-red-500 my-4">
            {props.errors["signature"].join(". ")}
          </p>
        )}
      </div>
      <Modal
        open={openSig}
        onClose={onCloseSigModal}
        center
        blockScroll={true}
        styles={customStyles}>
        <div className="relative">
          <h2 className="py-6 text-center text-16 text-open-sans bg-white w-full bg-white border-b">
            {t("PLEASE_DRAW_YOUR_SIGNATURE")}
          </h2>
          <div className="text-14 text-open-sans leading-8 max-h-full overflow-y-auto relative p-6">
            <SignaturePad
              penColor="black"
              ref={ref}
              confirmText="Save"
              imageType={"image/svg+xml"}
              canvasProps={{
                id: "signature1",
                width: 360,
                height: 300,
                className: "sigCanvas border",
              }}
            />
            <div className="flex space-x-6 pt-4 justify-between">
              <button
                onClick={handleClear}
                className="px-4 p-6 rounded-lg bg-blue-500 text-white text-14 outline-none">
                {t("CLEAR")}
              </button>
              <button
                onClick={handleOK}
                className="px-4 p-6 rounded-lg bg-blue-500 text-white text-14">
                {t("CONFIRM")}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default withTranslation()(SignatureSelector);
